<template>
  <div class="main-body">
    <div class="header">
      护理套餐
    </div>
    <div class="out">
      <div class="search2">

        <el-button size="mini" type="primary" :disabled="disabledAdd" @click.native="toggleModalAdd">添加</el-button>
        <el-button size="mini" type="success" :disabled="disableEdit" @click.native="handleEdit">编辑</el-button>

        <el-button size="mini" type="danger" v-show="handleStart" @click.native="handle(0)">启用</el-button>
        <el-button size="mini" type="danger" v-show="handleEnd" @click.native="handle(1)">禁用</el-button>

        <div style="clear: both;"></div>
      </div>

      <el-table class="table" size="mini" :data="tableData" v-loading="loading" :height="th" border style="width: 100%;" highlight-current-row @row-click='rowClick'>

        <el-table-column prop="name" label="名称"></el-table-column>

        <el-table-column prop="univalence" label="套餐总价(元/月)"></el-table-column>

        <el-table-column prop="nursingLevelName" label="护理等级"></el-table-column>

        <el-table-column prop="nursingLevelPrice" label="护理价格(元/月)"></el-table-column>

        <el-table-column
            prop="roomTypeDTO.name"
            label="房间类型">
        </el-table-column>
        <el-table-column
            prop="roomTypeDTO.num"
            label="几人间">
        </el-table-column>
        <el-table-column prop="roomTypePrice" label="房间价格(元/月)"></el-table-column>
        <el-table-column
            prop="Status"
            :formatter="statusTitle"
            label="套餐状态">
        </el-table-column>

      </el-table>
      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
              background
              layout="prev, pager, next"
              :total="totalItems"
              :page-size="20"
              @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>

    <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd"   v-on:getList="getList"></Add>
    <Edit ref="myEdit" v-show="showModalEdit" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit>

  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

import Edit from "./Edit";
import Add from "./Add";
import {getStaffCode} from "@/utils/auth";

export default {
  name: "Role",
  data(){
    return{
      loading:false,

      disabledAdd:false,
      disableEdit:true,

      showModalAdd:false,
      showModalEdit:false,
      handleStart:false,
      handleEnd:false,
      tableData:null,
      checkInfo:'',
      InstitutionArg:'',
      roomTypeList:[],
      totalItems: 0,
      pageSize:20,
      currentPage:1,
      th:0,
    }
  },
  components:{
    Add,Edit
  },
  created(){
    this.getList();

    this.th = this.$store.state.tableHeight;
  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      console.log(val);
      this.th = val;
    },
  },
  methods:{
    handleEdit() {

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"CheckinSetmeal/IsNotEdit",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode:getStaffCode(),
          checkinSetmealCode:this.checkInfo.checkinSetmealCode
        }
      }).then(
          (response) => {
            if (response.data.error == 0) {
              var data=response.data.data
              console.log(data.isNotEdit)
              if(data.isNotEdit){
                this.$refs.myEdit.init(this.checkInfo);
                this.showModalEdit = !this.showModalEdit;
              }else{
                this.$message.error('此套餐正在使用无法修改，若有需要请重新添加')
              }
            }else if(response.data.error == 1){
              this.$message({type: 'info', message: response.data.message});
            }
          }
      )
    },
    handle(status){
      let buttonName;
      if(status==0){
        buttonName = "启用";
      }else{
        buttonName = "禁用";
      }
      this.$confirm('确认'+buttonName+', 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true;
        this.$axios({
          method: 'post',
          url: this.$shopUrl+"CheckinSetmeal/Edit",
          data: {
            timeStr:timeStr,
            sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
            staffCode: getStaffCode(),
            name:this.checkInfo.name,
            univalence:this.checkInfo.univalence,
            nursingLevelCode:this.checkInfo.nursingLevelCode,
            type:this.checkInfo.type,
            roomTypeCode:this.checkInfo.roomTypeCode,
            status:status,
            checkinSetmealCode:this.checkInfo.checkinSetmealCode,
          }
        }).then(
            (response) => {
              this.loading = false;
              if (response.data.error == 0) {
                this.getList()
              }else if(response.data.error == 1){
                this.$message({type: 'info', message: response.data.message});
              }
            }
        )
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });

    },
    toggleModalAdd:function(){
      this.showModalAdd = !this.showModalAdd;
      this.$refs.myAdd.init();
    },
    closeAdd:function(){
      this.showModalAdd = !this.showModalAdd;
    },
    toggleModalEdit:function(){
      this.showModalEdit = !this.showModalEdit;
    },
    closeEdit:function(){
      this.showModalEdit = !this.showModalEdit;
    },

    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },

    getList(){
      this.loading=true;
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"CheckinSetmeal/Page",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
        }
      }).then( (response)=> {
        this.loading = false;
        this.disableEdit=true;
        this.handleStart=false
        this.handleEnd=false
        if(response.data.error == 0){
          this.tableData = response.data.data.list;
          this.totalItems = response.data.data.total;
        }else if(response.data.error == 1){
          this.$message({type: 'info', message: response.data.message});
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    statusTitle(row){
      if(row.status == 0){
        return "正常";
      }
      if(row.status == 1){
        return "禁用";
      }
      return "其它";
    },
    rowClick(row){
      this.checkInfo=row
      //if(this.menuButtonList.indexOf("编辑")!=-1){
        this.disableEdit =false;
      //}
      this.handleStart =false;
      this.handleEnd =false;

      if(row.status==0){
        if(this.menuButtonList.indexOf("禁用")!=-1){
          this.handleEnd =true;
        }
      }else{
        if(this.menuButtonList.indexOf("启用")!=-1){
          this.handleStart =true;
        }
      }

    }


  }
}
</script>

<style scoped>
.checkSetmeal /deep/ .el-table__body tr.current-row>td {
  background-color: #409EFF;
  color:#fff;
}
</style>
